import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.951 12.691A1 1 0 0 1 22 13v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7a1 1 0 0 1 .049-.31 4.223 4.223 0 0 0 2.094.553c.97 0 1.886-.33 2.619-.904a4.234 4.234 0 0 0 2.619.904c.97 0 1.886-.33 2.619-.904a4.234 4.234 0 0 0 2.619.904c.97 0 1.886-.33 2.62-.904a4.234 4.234 0 0 0 2.618.904c.762 0 1.476-.2 2.094-.552zm-2.094-.548a3.14 3.14 0 0 1-2.619-1.405 3.14 3.14 0 0 1-2.619 1.405A3.14 3.14 0 0 1 12 10.738a3.14 3.14 0 0 1-2.619 1.405 3.14 3.14 0 0 1-2.619-1.405A3.143 3.143 0 0 1 1 9.012V8.75c0-.241.056-.48.164-.696l1.884-3.768A.502.502 0 0 1 3.511 4 26295.53 26295.53 0 0 1 16.51 4h3.98a.507.507 0 0 1 .462.286l1.888 3.776c.107.213.161.45.16.688V9a3.145 3.145 0 0 1-3.143 3.143zM9 15a1 1 0 0 0-1 1v6h8v-6a1 1 0 0 0-1-1H9zm0 1h6v6H9v-6zM3.5 2h17a.5.5 0 1 1 0 1h-17a.5.5 0 1 1 0-1z"
});

var SvgStoreFilled = function SvgStoreFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgStoreFilled;